"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCurrentUser = exports.signout = exports.redirectToLogin = void 0;
var config_1 = require("./config");
/**
 * Accepts an environment and redirects to appropriate login url
 * based on the environment passed
 * @param environment
 */
function redirectToLogin(environment) {
    var susiHost = (0, config_1.config)(environment).Api.SUSI_HOST;
    window.location.href = "https://".concat(susiHost, "/?return_to=").concat(encodeURIComponent(location.href));
}
exports.redirectToLogin = redirectToLogin;
/**
 * Signs user out
 * @param environment
 */
function signout(environment) {
    var susiHost = (0, config_1.config)(environment).Api.SUSI_HOST;
    window.location.href = "https://".concat(susiHost, "/sign-out?return_to=").concat(encodeURIComponent(location.href));
}
exports.signout = signout;
/**
 * Gets current user from the api
 * or rejects if status === 401
 * @param environment
 * @param token
 */
function fetchCurrentUser(environment, token) {
    return new Promise(function (resolve, reject) {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status == 200) {
                resolve(JSON.parse(this.responseText));
            }
            else if (this.readyState === 4 && this.status === 401) {
                reject(this.status);
                redirectToLogin(environment);
            }
            else if (this.readyState === 4) {
                reject(this.status);
            }
        };
        var coreusersHost = (0, config_1.config)(environment).Api.CORE_USERS_HOST;
        xhttp.open('GET', 'https://' + coreusersHost + '/api/current_user', true);
        xhttp.setRequestHeader('Authorization', 'Bearer ' + token);
        xhttp.send();
    });
}
exports.fetchCurrentUser = fetchCurrentUser;
